/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkOrderTicketReportSummaryDto
 */
export interface WorkOrderTicketReportSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    executionResult?: WorkOrderTicketReportSummaryDtoExecutionResultEnum | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    summary?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    workPerformed?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    recommendation?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    technicianComment?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    faultCategory?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    faultDescription?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    confirmedSerialNumber?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    confirmedAssetIdentifier?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    pauseDurationMinutes?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderTicketReportSummaryDto
     */
    arrivedAt?: Date | null;
}


/**
 * @export
 */
export const WorkOrderTicketReportSummaryDtoExecutionResultEnum = {
    CompletedOk: 'COMPLETED_OK',
    CompletedWithIssue: 'COMPLETED_WITH_ISSUE',
    NotDone: 'NOT_DONE',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderTicketReportSummaryDtoExecutionResultEnum = typeof WorkOrderTicketReportSummaryDtoExecutionResultEnum[keyof typeof WorkOrderTicketReportSummaryDtoExecutionResultEnum];


/**
 * Check if a given object implements the WorkOrderTicketReportSummaryDto interface.
 */
export function instanceOfWorkOrderTicketReportSummaryDto(value: object): value is WorkOrderTicketReportSummaryDto {
    return true;
}

export function WorkOrderTicketReportSummaryDtoFromJSON(json: any): WorkOrderTicketReportSummaryDto {
    return WorkOrderTicketReportSummaryDtoFromJSONTyped(json, false);
}

export function WorkOrderTicketReportSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrderTicketReportSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'executionResult': json['executionResult'] == null ? undefined : json['executionResult'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'workPerformed': json['workPerformed'] == null ? undefined : json['workPerformed'],
        'recommendation': json['recommendation'] == null ? undefined : json['recommendation'],
        'technicianComment': json['technicianComment'] == null ? undefined : json['technicianComment'],
        'faultCategory': json['faultCategory'] == null ? undefined : json['faultCategory'],
        'faultDescription': json['faultDescription'] == null ? undefined : json['faultDescription'],
        'confirmedSerialNumber': json['confirmedSerialNumber'] == null ? undefined : json['confirmedSerialNumber'],
        'confirmedAssetIdentifier': json['confirmedAssetIdentifier'] == null ? undefined : json['confirmedAssetIdentifier'],
        'pauseDurationMinutes': json['pauseDurationMinutes'] == null ? undefined : json['pauseDurationMinutes'],
        'arrivedAt': json['arrivedAt'] == null ? undefined : (new Date(json['arrivedAt'])),
    };
}

export function WorkOrderTicketReportSummaryDtoToJSON(json: any): WorkOrderTicketReportSummaryDto {
    return WorkOrderTicketReportSummaryDtoToJSONTyped(json, false);
}

export function WorkOrderTicketReportSummaryDtoToJSONTyped(value?: WorkOrderTicketReportSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'executionResult': value['executionResult'],
        'summary': value['summary'],
        'workPerformed': value['workPerformed'],
        'recommendation': value['recommendation'],
        'technicianComment': value['technicianComment'],
        'faultCategory': value['faultCategory'],
        'faultDescription': value['faultDescription'],
        'confirmedSerialNumber': value['confirmedSerialNumber'],
        'confirmedAssetIdentifier': value['confirmedAssetIdentifier'],
        'pauseDurationMinutes': value['pauseDurationMinutes'],
        'arrivedAt': value['arrivedAt'] == null ? value['arrivedAt'] : value['arrivedAt'].toISOString(),
    };
}

